define('frontend-common-components/objectStorageConfig/js/views/layouts/baseAddStorageLayout',[
    './base/baseLayoutView',
    'jquery',
    '../../constants/events',
    'underscore'
], function (BaseItemLayout, $, Events, _) {
    'use strict';

    return BaseItemLayout.extend({

        className: 'add-cloud-storage-view',

        constructor: function () {
            this.closeAddStorageViewProxy = _.bind(this.closeAddStorageView, this);
            this.onDocumentKeyDownProxy = _.bind(this.onDocumentKeyDown, this);
            this.onDocumentClickProxy = _.bind(this.onDocumentClick, this);
            BaseItemLayout.apply(this, arguments);
        },

        onShow: function () {
            this.registerDocumentHandEventHandlers();
        },
        
        registerDocumentHandEventHandlers: function () {
            $(document).on('click', this.onDocumentClickProxy);
            $('*[data-toggle="dropdown"]').on('click', this.closeAddStorageViewProxy);
            $(document).on('keydown', this.onDocumentKeyDownProxy);
        },

        unregisterDocumentHandEventHandlers: function () {
            $(document).off('click', this.onDocumentClickProxy);
            $('*[data-toggle="dropdown"]').off('click', this.closeAddStorageViewProxy);
            $(document).off('keydown', this.onDocumentKeyDownProxy);
        },

        onDocumentClick: function (event) {
            if (!this.eventOriginatedFromAddButton(event) && !this.eventOriginatedFromInsidePanel(event)) {
                this.closeAddStorageView();
            }
        },

        onDocumentKeyDown: function (event) {
            if (event.which === 27) {
                this.closeAddStorageView();
            }
        },

        eventOriginatedFromAddButton: function (event) {
            return $(event.target).hasClass('add-storage-config');
        },

        eventOriginatedFromInsidePanel: function (event) {
            var $eventTarget = $(event.target);
            return $eventTarget.closest('.panel-content').length;
        },

        closeAddStorageView: function () {
            this.unregisterDocumentHandEventHandlers();
            this.trigger(Events.closeAddStorage);
        }
    });

});
